module.exports = __webpack_public_path__ + "static/3-before.87b430c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3-before.jpg
// module id = 424
// module chunks = 221374088121123